import React, { useContext } from "react";
import PropTypes from "prop-types";
import { css } from "@emotion/react";

import { baseColor2, inputDefaultColor } from "../styles/color";
import { boxShadow2, boxShadow3 } from "../styles/common";
import { breakpointMd } from "../styles/layout";
import DefaultCompanyLogo from "../images/default-company-logo.svg";
import { Link } from "gatsby";
import { AmplitudeContext } from "../context/amplitude";

const featuredStyles = css`
  display: grid;
  grid-template-columns: 49px auto;
  gap: 0.75rem;
  padding: 0.75rem;
  background-color: ${inputDefaultColor};
  border-radius: 0.5rem;
  box-shadow: ${boxShadow2};
  transition: box-shadow 250ms ease-out;
  cursor: pointer;
  text-decoration: none;
  color: ${baseColor2};

  &:hover {
    box-shadow: ${boxShadow3};
  }

  .company-logo {
    height: 49px;
    width: 49px;
    border-radius: 50%;
  }

  .data {
    display: grid;
    gap: 0.5rem;

    .job-title {
      font-size: 1.125rem;
      font-weight: 600;
    }

    .company-name {
      font-size: 0.875rem;
      font-weight: 500;
    }
  }

  @media only screen and (min-width: ${breakpointMd}) {
    padding: 1rem;
    gap: 1rem;
  }
`;

const FeaturedJob = ({ jobData }) => {
  const monitor = useContext(AmplitudeContext);

  const logJobPostClick = () => {
    monitor.logEvent("JOB POST CLICKED", {
      jobId: jobData.id,
      missionAreas: jobData.missionAreas,
      jobLocation: jobData.location,
    });
  };

  return (
    <Link
      css={featuredStyles}
      to={`jobs/${jobData.id}`}
      onClick={logJobPostClick}
    >
      <img
        className="company-logo"
        src={jobData.photo || DefaultCompanyLogo}
        alt={jobData.companyName}
      />
      <div className="data">
        <div className="job-title">{jobData.jobTitle}</div>
        <div className="company-name">
          {jobData.companyName} • {jobData.location}
        </div>
      </div>
    </Link>
  );
};

FeaturedJob.propTypes = {
  jobData: PropTypes.object,
};

export default FeaturedJob;
